import { useEffect, useState } from "react";
import { makeRequestAuth } from "../../../_config/api";

const SplineChart = () => {
  const [summaryData, setSummaryData] = useState([
    { title: "Total User", value: 0 },
    { title: "Total Active User", value: 0 },
    { title: "Total Exams", value: 0 },
  ]);
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await makeRequestAuth("post", "/admin/dashboard");

        if (response?.code === 0 && !response.error) {
          setSummaryData([
            { title: "Total User", value: response?.data.userCount },
            { title: "Total Active User", value: response?.data.activeUser },
            { title: "Total Exams", value: response?.data.exam },
          ]);
        } else {
          console.error("Server Error:", response?.data?.message || "Unknown error");
        }


      } catch (error) {
        console.error("Dashboard data fetch failed:", error);
      }
    };

    fetchDashboardData();
  }, []);

  return (
    <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {summaryData.map((item, index) => (
        <div
          key={index}
          className="bg-white rounded-2xl shadow-md p-6 w-full"
        >
          <h2 className="text-sm font-semibold text-gray-600">{item.title}</h2>
          <p className="text-3xl font-bold text-gray-800 mt-2">{item.value}</p>
        </div>
      ))}
    </section>
  );
};

export default SplineChart;
